module.exports = __webpack_public_path__ + "static/media/news.b72cafc4.png";